import React, { useState } from 'react';
import { SurveyDetailsTab } from './tabs/SurveyDetailsTab';
import { RoutesTab } from './tabs/RoutesTab';
import { POIsTab } from './tabs/POIsTab';
import { FilesTab } from './tabs/FilesTab';

const TABS = [
  { id: 'details', label: 'Survey Details' },
  { id: 'routes', label: 'Routes' },
  { id: 'pois', label: 'Points of Interest' },
  { id: 'files', label: 'Files & Documents' }
];

export const SurveyInfoTabs = ({ survey }) => {
  if (!survey) {
    return (
      <div className="p-4 text-center text-gray-400">
        No survey data available
      </div>
    );
  }

  const [activeTab, setActiveTab] = useState('details');

  return (
    <div className="bg-[#2A2B2E] rounded-lg overflow-hidden">
      {/* Tab Navigation */}
      <div className="flex border-b border-gray-700">
        {TABS.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-6 py-3 text-sm font-medium transition-colors ${
              activeTab === tab.id
                ? 'text-white border-b-2 border-red-500'
                : 'text-gray-400 hover:text-white hover:bg-gray-700/50'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="p-6">
        {activeTab === 'details' && <SurveyDetailsTab survey={survey} />}
        {activeTab === 'routes' && <RoutesTab survey={survey} />}
        {activeTab === 'pois' && <POIsTab survey={survey} />}
        {activeTab === 'files' && <FilesTab survey={survey} />}
      </div>
    </div>
  );
};